export const i18nConfigForTest = {
  fallbackLng: 'en',
  resources: {
    en: {},
  },
};
